document.addEventListener('DOMContentLoaded', async function () {
    document.addEventListener("ab:sticky-default-condition", async function (event) {
        try {
            const defaultSelectedCondition = await new Promise((resolve, reject) => {
                const startTime = Date.now();

                const checkElement = setInterval(() => {
                    const element = document.querySelector(`div[value="${event.detail.variantId}"]`);
                    if (element) {
                        clearInterval(checkElement);
                        resolve(element);
                    } else if (Date.now() - startTime > 1000) {
                        clearInterval(checkElement);
                        reject(new Error(`Timeout: sticky default condition element not found!`));
                    }
                }, 100);
            });
            defaultSelectedCondition.dispatchEvent(new Event('click'));
        } catch (e) {
            console.info(e);
        }
    });
    if (!(await abTests.evaluateStickyBar())) {
        return;
    }
    if (window.innerWidth < 768) {

        const mainBasketButton = document.querySelector('.product-form__buttons .product-form__submit');
        if (!mainBasketButton) {
            console.error('Stopping ab test because "Add to Basket" button does not exists');
            return;
        }
        const overlay = document.createElement('div');
        overlay.id = 'shadow-overlay';
        overlay.className = 'shadow-overlay hidden';

        document.body.appendChild(overlay);

        const stickyBar = document.createElement("div");
        stickyBar.id = 'sticky-add-to-basket';
        stickyBar.innerHTML = `
                                  <div id="sticky-condition-selector">
                                    <div class='sticky-selected'></div>
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M3 4.5L6 7.5L9 4.5" stroke="#1D1D1D" stroke-width="2" stroke-miterlimit="3.8637" stroke-linecap="square"/>
                                    </svg>
                                  </div>
                                  <button id='sticky-basket-btn'>Add to Basket</button>
                                  `;

        document.body.appendChild(stickyBar);

        const mainConditionSelector = document.querySelector(".condition-selector");

        if (mainConditionSelector) {
            generateStickyConditionOptions();

            const dropdownOptions = document.querySelector(".sticky-dropdown-options");
            document.addEventListener("ab:sticky-condition", function (event) {
                document.querySelector(`div[value="${event.detail.variantId}"]`).dispatchEvent(new Event('click'));
            });

            document.addEventListener("ab:sticky-condition-deal", async function (event) {
                try {
                    const dealBannerSkeleton = await new Promise((resolve, reject) => {
                        const startTime = Date.now();

                        const checkElement = setInterval(() => {
                            const element = document.querySelector(`div[value="${event.detail.variant.getAttribute('value')}"] .sticky-dropdown-option-deal-banner .sticky-deal-banner`);
                            if (element) {
                                clearInterval(checkElement);
                                resolve(element);
                            } else if (Date.now() - startTime > 1000) {
                                clearInterval(checkElement);
                                reject(new Error(`Timeout: sticky deal banner element not found!`));
                            }
                        }, 100);
                    });
                    dealBannerSkeleton.style.display = "flex";
                } catch (error) {
                    console.error(error);
                }
            });

            document.querySelectorAll('.sticky-dropdown-option').forEach(option => {
                option.addEventListener("click", function () {
                    document.querySelector('.sticky-selected').innerHTML = this.children[0].innerHTML;
                    const originalConditionButton = document.querySelector(`input[type="radio"][value="${this.getAttribute('value')}"]`);
                    if (originalConditionButton && !originalConditionButton.checked) {
                        originalConditionButton.nextElementSibling.dispatchEvent(new Event('click'));
                    }
                    if (!dropdownOptions.classList.contains('hidden')) {
                        dropdownOptions.classList.toggle('hidden');
                        overlay.classList.toggle('hidden');
                        document.body.style.overflow = "";
                    }
                });
            });
            document.querySelector('#sticky-condition-selector').addEventListener('click', event => {
                dropdownOptions.classList.toggle('hidden');
                overlay.classList.toggle('hidden');
                document.body.style.overflow = "hidden";
            });

            overlay.addEventListener('click', function () {
                dropdownOptions.classList.toggle('hidden');
                overlay.classList.toggle('hidden');
                document.body.style.overflow = "";
            });

            //handleSwipeDownEvent
            const touchDiv = document.getElementById("sticky-dropdown-indicator");

            let startY = 0;

            touchDiv.addEventListener("touchstart", (e) => {
                startY = e.touches[0].clientY;
            });

            touchDiv.addEventListener("touchmove", (e) => {
                const moveY = e.touches[0].clientY;

                if (moveY - startY > 50) {
                    dropdownOptions.style.transition = "transform 0.3s ease";
                    dropdownOptions.style.transform = "translateY(100%)";

                }
            });
            dropdownOptions.addEventListener("transitionend", () => {
                dropdownOptions.style.transition = "";
                dropdownOptions.style.transform = "";
                dropdownOptions.classList.toggle('hidden');
                overlay.classList.toggle('hidden');
                document.body.style.overflow = "";
            });

        }
        document.getElementById("sticky-basket-btn").addEventListener("click", function () {
            mainBasketButton.click();
        });

        function isElementInViewport(el) {
            if (!el) return false;
            let rect = el.getBoundingClientRect();
            return rect.bottom > 0 && rect.top < window.innerHeight;
        }

        function handleScroll() {
            if (mainBasketButton && isElementInViewport(mainBasketButton)) {
                stickyBar.style.display = "none";
            } else {
                stickyBar.style.display = "flex";
            }
        }

        window.addEventListener("scroll", handleScroll);
    }
});

function generateStickyConditionOptions() {
    const variantsSelectorData = variantsFilterFn(variantsData, countryIsoCode, marketISO, blockedCountries);

    if (variantsSelectorData.length > 0) {
        const dropdownOptions = document.createElement("div");
        dropdownOptions.id = 'sticky-dropdown-options';
        dropdownOptions.className = 'sticky-dropdown-options hidden';
        const dropdownIndicator = document.createElement("div");
        dropdownIndicator.id = 'sticky-dropdown-indicator';
        dropdownIndicator.className = 'sticky-dropdown-indicator';
        dropdownIndicator.innerHTML = ` <svg width="45" height="4" viewBox="0 0 45 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <rect x="0.5" width="44" height="4" rx="2" fill="#D9D9D9"/>
                                        </svg>`;
        const dropdownHeader = document.createElement("div");
        dropdownHeader.id = 'sticky-dropdown-header';
        dropdownHeader.className = 'sticky-dropdown-header';
        dropdownHeader.innerText = translations.products.product.select_condition;

        dropdownOptions.innerHTML = variantsSelectorData.map((variant, index) => {
            const variantCondition = translations.products.product.condition[variant.condition.toLowerCase()];
            const isNew = variant.condition.replace('_', ' ').toLowerCase() === 'new';

            return `
                    <div class="sticky-dropdown-option ${isNew ? 'new' : ''}"
                         id="sticky-variants-selector-${section_Id}-${index}"
                         name="sticky-condition"
                         value="${variant.id}"
                         data-collection="${collectionIds}"
                         data-note="${variant.note}"
                         data-sku="${variant.sku}"
                         data-condition="${variantCondition}"
                         data-price="${variant.price}"
                         data-stock="${variant.inventory_quantity}">

                        <div class="sticky-dropdown-option-condition-price">
                            <span style="font-family: var(--wob-typography-font-body); font-weight: 400;">
                                ${variantCondition} -
                            </span>
                            <span class="amount" style="font-family: var(--wob-typography-font-body-bold); font-weight: 700;">
                                ${store_currency_sign}${(variant.price / 100).toFixed(2)}
                            </span>
                        </div>

                        <div class="sticky-dropdown-option-deal-banner">
                            <span class="sticky-deal-banner">Deal!</span>
                        </div>
                    </div>
                `;
        }).join(``);

        dropdownOptions.prepend(dropdownHeader);
        dropdownOptions.prepend(dropdownIndicator);

        document.body.appendChild(dropdownOptions);
    }
}